import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import logo from "@/assets/logo.png";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated, please log in");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-app flex flex-col" data-testid="reset-page">
      <div className="max-w-md w-full mx-auto px-6 py-10 flex-1 flex flex-col justify-center">
        <Link to="/" className="mb-8 flex justify-center">
          <img src={logo} alt="Meno Flames and Finesse" className="h-24 w-auto" />
        </Link>
        <div className="bg-white rounded-3xl card-shadow p-8">
          <h1 className="font-serif text-2xl font-bold text-ink">Choose a new password</h1>
          {!token ? (
            <p className="text-ink-soft text-sm mt-3">
              This reset link is missing or invalid. Please request a new one from the{" "}
              <Link to="/forgot-password" className="text-brand font-semibold">forgot password</Link> page.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <input
                data-testid="reset-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                className="w-full rounded-xl border border-subtle bg-app px-4 py-3 text-ink outline-none focus:border-[var(--brand)]"
                placeholder="New password (min 6 characters)"
              />
              {error && <div className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">{error}</div>}
              <button
                data-testid="reset-submit"
                disabled={busy}
                className="w-full bg-brand hover:bg-[var(--brand-hover)] text-white font-semibold py-3.5 rounded-full transition-colors disabled:opacity-60"
              >
                {busy ? "Updating…" : "Update password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
